import React from "react"

import { Icon, Value, Wrapper } from "./styles"

const Infographic = ({ icon, value, children, direction, colour, lg }) => {
  const iconWithProps = React.cloneElement(icon, { colour })
  return (
    <Wrapper direction={direction}>
      <Icon direction={direction} lg={lg}>
        {iconWithProps}
      </Icon>
      <div>
        <Value colour={colour} direction={direction}>
          {value}
        </Value>
        {children}
      </div>
    </Wrapper>
  )
}

export default Infographic
